import script from "./ProposalVotes.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalVotes.vue?vue&type=script&setup=true&lang=js"

import "./ProposalVotes.vue?vue&type=style&index=0&id=260e7c96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260e7c96"]])

export default __exports__